import React, { Component } from 'react'
import './RadioLabelGroup.css'

class RadioLabel extends Component {
  render() {
    const { label, value, onChange, selected } = this.props
    return (
      <div className={selected? "group-option selected-option" : "group-option"} onClick={() => onChange(value)}>
        {label}
      </div>
    )
  }
}

export class RadioLabelGroup extends Component {
  render() {
    const {options, value, onChange} = this.props
    return (
      <div className="radio-group">
        {options.map((o, i) => <RadioLabel key={i} value={o.value} label={o.label} onChange={onChange} selected={o.value === value} />)}
      </div>
    )
  }
}

export default RadioLabelGroup



// WEBPACK FOOTER //
// ./src/components/RadioLabelGroup/index.js